import type { ToolMeta } from './registry';

// The most suppliers one comparison takes. The card scrolls sideways, so five still fit.
export const MAX_COMPARED = 5;

export const compareSuppliersMeta = {
  description:
    'Compares 2 to 5 named suppliers, or the newest saved venues, side by side with pricing, capacity, ratings, and location.',
  examples: [
    'Compare Hedsor House and Cliveden House',
    "Which is better, The Savoy or Claridge's?",
    'Compare The Goring, The Connaught, and The Dorchester',
  ],
  value: 'two to five suppliers side by side',
  grounding: 'venue',
} as const satisfies ToolMeta;
